import React, { useEffect, useState } from 'react';
import axios from 'axios';
import apiConfig from '../../../config/apiConfig';
import './ImageComponent.css'
const ImageComponent = ({ imagePath }) => {
    const [imgSrc, setImgSrc] = useState('');

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const response = await axios.get(`${apiConfig.endpoints.quizService.baseURL}/mi${imagePath}`, {
                    responseType: 'blob',
                });
                const imgUrl = URL.createObjectURL(response.data);
                setImgSrc(imgUrl);
            } catch (error) {
                console.error('Error fetching image:', error);
            }
        };
        fetchImage();
    }, [imagePath]);

    if (!imgSrc) return <div>
        <span className="loading-content"><span className="spinner" /> Loading image...</span>
    </div>;

    return <img className='quistionImg' src={imgSrc} loading="lazy" alt="QuestionImage" />;
};

export default ImageComponent;
